import { Grid } from "@mui/material";
import { LocalizationProvider, TimePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from "dayjs";
import { useSelector } from "react-redux";
 
import TextInput from "../../../components/common/TextInput";
import RadioButtonGroup from "../../../components/common/RadioButtonGroup";
import Scheduler from "../../../components/Scheduler/Scheduler";
import DatePicker from "../../../components/common/DatePicker";
 
const JobDetailScheduleConfig = (props) => {
  const getJobDetailsData = useSelector((state) => state?.getJobInputDetail);
  const today = dayjs();
 
  const handleStartDateChange = (newValue) => {
    if (newValue && dayjs(newValue).isValid()) {
      props.setScheduledStartDate(dayjs(newValue).format('YYYY-MM-DD'));
      props.setBtnDisabled(!newValue || !props.scheduledTime);
    } else {
      props.setScheduledStartDate(null);
    }
  };
 
  const handleStartTimeChange = (newValue) => {
    if (newValue && dayjs(newValue).isValid()) {
      props.setScheduledTime(dayjs(newValue).format('HH:mm:ss'));
      props.setBtnDisabled(!props.scheduledStartDate || !newValue);
    } else {
      props.setScheduledTime(null);
    }
  }

  return (
    <>
      <Grid
        container
        xs={12}
        mt={2}
        sx={{
          padding: "0 15px",
          borderRadius: "10px",
          flexDirection: "column",
        }}
      >
        <h4>Scheduling Parameters</h4>
        <form>
          <Grid
            item
            md={4}
            xs={12}
            sx={{
              display: "flex",
              flexDirection: "column",
              "& .MuiFormControl-root": { width: "100%" },
              "& .MuiFormLabel-root": { fontSize: "14px" },
              "& .MuiInputBase-root>Input": { height: "80% !important" },
            }}
          >
            <label className="label-position" htmlFor="hierarchy">
              Label*
            </label>
            <TextInput
              label="Label"
              name="prodCriticalItem"
              value={props.formData?.prodCriticalItem}
              onChange={props.handleChange}
            />
          </Grid>
          <Grid
            item
            md={6}
            xs={12}
            mt={2}
            sx={{
              display: "flex",
              flexDirection: "column",
              "& .MuiFormControl-root": { width: "100%" },
              "& .MuiFormLabel-root": { fontSize: "14px" },
              "& .MuiInputBase-root>Input": { height: "80% !important" },
            }}
          >
            <label className="label-position" htmlFor="hierarchy">
              Description
            </label>
            <TextInput
              label="Description"
              name="materialTypeDesc"
              value={props.formData?.materialTypeDesc}
              onChange={props.handleChange}
            />
          </Grid>
          <Grid
            item
            xs={6}
            mt={2}
            sx={{
              display: "flex",
              flexDirection: "column",
              "& .MuiFormControl-root": { width: "100%" },
              "& .MuiFormLabel-root": { fontSize: "14px" },
              "& .MuiInputBase-root>Input": { height: "80% !important" },
            }}
          >
            <label className="label-position" htmlFor="hierarchy">
              Schedule Type
            </label>
            <RadioButtonGroup
              props={[
                {
                  label: "Single-Run",
                  value: "Single-Run",
                  labelPlacement: "end",
                  size: "small",
                  disabled: getJobDetailsData?.data?.scheduleType === "Recurring" || getJobDetailsData?.data?.scheduleType === "One-Time-Schedule",
                },
                {
                  label: "One-Time-Schedule",
                  value: "One-Time-Schedule",
                  labelPlacement: "end",
                  size: "small",
                  disabled: getJobDetailsData?.data?.scheduleType === "Recurring" || getJobDetailsData?.data?.scheduleType === "Single-Run"
                },
                {
                  label: "Recurring",
                  value: "Recurring",
                  labelPlacement: "end",
                  size: "small",
                  disabled: getJobDetailsData?.data?.scheduleType === "One-Time-Schedule" || getJobDetailsData?.data?.scheduleType === "Single-Run"
                },
              ]}
              value={getJobDetailsData?.data?.scheduleType}
              onChange={props?.handleRadioChange}
              name="scheduleType"
            />
          </Grid>
          {getJobDetailsData?.data?.scheduleType === "Recurring" ? (
            <Grid
              item
              xs={12}
              mt={2}
              sx={{
                display: "flex",
                flexDirection: 'column'
              }}
            >
              <Scheduler scheduleValue={props.scheduleValue} setScheduleValue={props.setScheduleValue} />
              <Grid item md={8} xs={12} mt={2}
                sx={{
                  display: "flex",
                  paddingTop: "5px !important",
                  "& .MuiFormControl-root": { width: "80%" },
                  "& .MuiFormLabel-root": { fontSize: "14px" },
                }}
              >
                <Grid item md={4} xs={12}>
                  <DatePicker
                      name="scheduledStartDate"
                      label="Scheduled Start Date*"
                      value={dayjs(props?.scheduledStartDate)}
                      onChange={handleStartDateChange}
                      minDate={today}
                    />
                </Grid>
              </Grid>
            </Grid>
          ):
          getJobDetailsData?.data?.scheduleType === "One-Time-Schedule" ? (
            <Grid item md={8} xs={12} mt={2}
              sx={{
                display: "flex",
                paddingTop: "5px !important",
                "& .MuiFormControl-root": { width: "80%" },
                "& .MuiFormLabel-root": { fontSize: "14px" },
              }}
            >
              <Grid item md={4} xs={12}>
                <DatePicker
                    name="scheduledStartDate"
                    label="Scheduled Start Date*"
                    value={dayjs(props?.scheduledStartDate)}
                    onChange={handleStartDateChange}
                    minDate={today}
                  />
              </Grid>
              <Grid item md={4} xs={12}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <TimePicker
                      label="Scheduled Start Time*"
                      ampm={false}
                      views={['hours', 'minutes', 'seconds']}
                      value={dayjs(getJobDetailsData?.data?.scheduleStartTime, 'HH:mm:ss')}
                      onChange={handleStartTimeChange}
                      sx={{height: '20px'}}
                      slotProps={{ textField: { size: 'small' } }}
                    />
                  </LocalizationProvider>
              </Grid>
            </Grid>
          ) :
          ''
          }
        </form>
      </Grid>
    </>
  );
};
 
export default JobDetailScheduleConfig;